import React from 'react';
import { Modal, Form, DatePicker, Input, Button } from 'antd';

const FilterModal = ({ visible, onCancel, onFilter }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then((values) => {
      onFilter(values);
    });
  };

  return (
    <Modal
      title="Filter Transactions"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Filter
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="transactionId" label="Transaction ID">
          <Input placeholder="Transaction ID" />
        </Form.Item>
        <Form.Item name="userId" label="User ID">
          <Input placeholder="User ID" />
        </Form.Item>
        <Form.Item name="reference" label="Reference">
          <Input placeholder="Reference" />
        </Form.Item>
        <Form.Item name="startDate" label="Start Date">
          <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="endDate" label="End Date">
          <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FilterModal;
